import { ASnackbar } from '@adornis/adornis-components/a-snackbar.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex';
import '@adornis/file-utils/client/x-image';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @element wtg-event-card
 */
@customElement('wtg-event-card')
export class WTGEventCard extends ChemistryLitElement {
  @property({ attribute: 'cover-img' }) coverImg = '';
  @property({ attribute: 'org-name' }) orgName = '';
  @property({ attribute: 'org-img' }) orgImageSource = '';
  @property() title = '';
  @property() location = '';
  @property() href = '';

  override render() {
    return html`
      <ge-card ${css({ padding: '0', width: '100%', height: '100%' })}>
        <x-flex h100>
          <x-image .value=${this.coverImg} mode="cover" ${css({ height: '200px', width: '100%' })}></x-image>

          <x-flex space="md" padding="md" crossaxis-start flex>
            <x-flex horizontal crossaxis-center space="md">
              <x-image
                .value=${this.orgImageSource}
                mode="cover"
                ${css({ width: '30px', height: '30px', borderRadius: '50%', overflow: 'hidden' })}
              ></x-image>
              <ge-text tone="subtle"> ${this.orgName} </ge-text>
            </x-flex>
            <ge-h3> ${this.title} </ge-h3>
            <ge-text flex> ${this.location} </ge-text>
            <ge-button
              href=${this.href}
              @click=${() => {
                if (!this.href) ASnackbar.show('Link is in process.');
              }}
            >
              i wanna go
            </ge-button>
          </x-flex>
        </x-flex>
      </ge-card>
    `;
  }
}
